import R from 'ramda'

// Mapping form actions to widget actions
import {
  isCallEndpointFormAction,
  convertCallEndpointFormActionToWidgetAction
} from './form-to-widget/call-endpoint'
import {
  isGoogleAnalyticsTrackEventFormAction,
  convertGoogleAnalyticsTrackEventFormActionToWidgetAction
} from './form-to-widget/google-analytics-track-event'
import {
  isMosaicOptInFormAction,
  convertMosaicOptInFormActionToWidgetAction
} from './form-to-widget/mosaic-opt-in'
import {
  isMosaicOptOutFormAction,
  convertMosaicOptOutFormActionToWidgetAction
} from './form-to-widget/mosaic-opt-out'
import {
  isOptInFormAction,
  convertOptInFormActionToWidgetAction
} from './form-to-widget/opt-in'
import {
  isOptOutFormAction,
  convertOptOutFormActionToWidgetAction
} from './form-to-widget/opt-out'
import {
  isOverlayFormAction,
  convertOverlayFormActionToWidgetAction
} from './form-to-widget/overlay'
import {
  isSendBlastFormAction,
  convertSendBlastFormActionToWidgetAction
} from './form-to-widget/send-blast'
import {
  isSendDarkReplyFormAction,
  convertSendDarkReplyFormActionToWidgetAction
} from './form-to-widget/send-dark-reply'
import {
  isSendDarkTweetFormAction,
  convertSendDarkTweetFormActionToWidgetAction
} from './form-to-widget/send-dark-tweet'
import {
  isSendDmFormAction,
  convertSendDmFormActionToWidgetAction
} from './form-to-widget/send-dm'
import {
  isSendEmailFormAction,
  convertSendEmailFormActionToWidgetAction
} from './form-to-widget/send-email'
import {
  isGoogleSheetAppendFormAction,
  convertGoogleSheetAppendFormActionToWidgetAction
} from '../common/form-to-widget/google-sheet-append'
import {
  isSpeedThreadStartFormType,
  convertSpeedThreadStartToWidget
} from './form-to-widget/start-speed-thread'

import {
  isSpeedThreadStopFormType,
  convertSpeedThreadStopToWidget
} from './form-to-widget/stop-speed-thread'

import {
  isSpeedThreadResetFormType,
  convertSpeedThreadResetToWidget
} from './form-to-widget/reset-speed-thread'

import {
  isTimedThreadDisplayType,
  convertAddFormToWidget
} from './form-to-widget/add-timed-thread-activity'

// Mapping form widget actions to form actions

import {
  isCallEndpointWidgetAction,
  convertCallEndpointWidgetActionToFormAction
} from './widget-to-form/call-endpoint'
import {
  isGoogleAnalyticsTrackEventWidgetAction,
  convertGoogleAnalyticsTrackEventWidgetActionToFormAction
} from './widget-to-form/google-analytics-track-event'
import {
  isMosaicOptInWidgetAction,
  convertMosaicOptInWidgetActionToFormAction
} from './widget-to-form/mosaic-opt-in'
import {
  isMosaicOptOutWidgetAction,
  convertMosaicOptOutWidgetActionToFormAction
} from './widget-to-form/mosaic-opt-out'
import {
  isOptInWidgetAction,
  convertOptInWidgetActionToFormAction
} from './widget-to-form/opt-in'
import {
  isOptOutWidgetAction,
  convertOptOutWidgetActionToFormAction
} from './widget-to-form/opt-out'
import {
  isOverlayGifWidgetAction,
  convertOverlayGifWidgetActionToFormAction
} from './widget-to-form/overlay-gif'
import {
  isOverlayImageWidgetAction,
  convertOverlayImageWidgetActionToFormAction
} from './widget-to-form/overlay-image'
import {
  isSendBlastWidgetAction,
  convertSendBlastWidgetActionToFormAction
} from './widget-to-form/send-blast'
import {
  isSendDarkReplyWidgetAction,
  convertSendDarkReplyWidgetActionToFormAction
} from './widget-to-form/send-dark-reply'
import {
  isSendDarkTweetWidgetAction,
  convertSendDarkTweetWidgetActionToFormAction
} from './widget-to-form/send-dark-tweet'
import {
  isSendDmWidgetAction,
  convertSendDmWidgetActionToFormAction
} from './widget-to-form/send-dm'
import {
  isSendEmailWidgetAction,
  convertSendEmailWidgetActionToFormAction
} from './widget-to-form/send-email'
import {
  isSendReplyWidgetAction,
  convertSendReplyWidgetActionToFormAction
} from './widget-to-form/send-reply'
import {
  isSendTweetWidgetAction,
  convertSendTweetWidgetActionToFormAction
} from './widget-to-form/send-tweet'
import {
  isGoogleSheetAppendWidgetAction,
  convertGoogleSheetAppendWidgetActionToFormAction
} from '../common/widget-to-form/google-sheet-append'
import {
  isSpeedThreadStartWidgetType,
  convertSpeedThreadStartToForm
} from './widget-to-form/start-speed-thread'

import {
  isSpeedThreadStopWidgetType,
  convertSpeedThreadStopToForm
} from './widget-to-form/stop-speed-thread'

import {
  isSpeedThreadResetWidgetType,
  convertSpeedThreadResetToForm
} from './widget-to-form/reset-speed-thread'

import {
  isAddTimedWidgetType,
  convertAddTimedWidgetToForm
} from './widget-to-form/add-timed-thread-activity'

const mapTwitterFormActionsToWidgetActions = R.map(
  R.cond([
    [isCallEndpointFormAction, convertCallEndpointFormActionToWidgetAction],
    [
      isGoogleAnalyticsTrackEventFormAction,
      convertGoogleAnalyticsTrackEventFormActionToWidgetAction
    ],
    [isMosaicOptInFormAction, convertMosaicOptInFormActionToWidgetAction],
    [isMosaicOptOutFormAction, convertMosaicOptOutFormActionToWidgetAction],
    [isOptInFormAction, convertOptInFormActionToWidgetAction],
    [isOptOutFormAction, convertOptOutFormActionToWidgetAction],
    [isOverlayFormAction, convertOverlayFormActionToWidgetAction],
    [isSendBlastFormAction, convertSendBlastFormActionToWidgetAction],
    [isSendDarkReplyFormAction, convertSendDarkReplyFormActionToWidgetAction],
    [isSendDarkTweetFormAction, convertSendDarkTweetFormActionToWidgetAction],
    [isSendDmFormAction, convertSendDmFormActionToWidgetAction],
    [isSendEmailFormAction, convertSendEmailFormActionToWidgetAction],
    [
      isGoogleSheetAppendFormAction,
      convertGoogleSheetAppendFormActionToWidgetAction
    ],
    [isSpeedThreadStartFormType, convertSpeedThreadStartToWidget],
    [isSpeedThreadStopFormType, convertSpeedThreadStopToWidget],
    [isSpeedThreadResetFormType, convertSpeedThreadResetToWidget],
    [isTimedThreadDisplayType, convertAddFormToWidget],
    [R.T, R.identity]
  ])
)

const mapTwitterWidgetActionsToFormActions = R.map(
  R.cond([
    [isCallEndpointWidgetAction, convertCallEndpointWidgetActionToFormAction],
    [
      isGoogleAnalyticsTrackEventWidgetAction,
      convertGoogleAnalyticsTrackEventWidgetActionToFormAction
    ],
    [isMosaicOptInWidgetAction, convertMosaicOptInWidgetActionToFormAction],
    [isMosaicOptOutWidgetAction, convertMosaicOptOutWidgetActionToFormAction],
    [isOptInWidgetAction, convertOptInWidgetActionToFormAction],
    [isOptOutWidgetAction, convertOptOutWidgetActionToFormAction],
    [isOverlayGifWidgetAction, convertOverlayGifWidgetActionToFormAction],
    [isOverlayImageWidgetAction, convertOverlayImageWidgetActionToFormAction],
    [isSendBlastWidgetAction, convertSendBlastWidgetActionToFormAction],
    [isSendDarkReplyWidgetAction, convertSendDarkReplyWidgetActionToFormAction],
    [isSendDarkTweetWidgetAction, convertSendDarkTweetWidgetActionToFormAction],
    [isSendDmWidgetAction, convertSendDmWidgetActionToFormAction],
    [isSendEmailWidgetAction, convertSendEmailWidgetActionToFormAction],
    [isSendReplyWidgetAction, convertSendReplyWidgetActionToFormAction],
    [isSendTweetWidgetAction, convertSendTweetWidgetActionToFormAction],
    [
      isGoogleSheetAppendWidgetAction,
      convertGoogleSheetAppendWidgetActionToFormAction
    ],
    [isSpeedThreadStartWidgetType, convertSpeedThreadStartToForm],
    [isSpeedThreadStopWidgetType, convertSpeedThreadStopToForm],
    [isSpeedThreadResetWidgetType, convertSpeedThreadResetToForm],
    [isAddTimedWidgetType, convertAddTimedWidgetToForm],
    [R.T, R.identity]
  ])
)

export {
  mapTwitterFormActionsToWidgetActions,
  mapTwitterWidgetActionsToFormActions
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/index.js